import { createSelector } from "reselect";

export const extensionIDSelector = (state) => state.chrome;

export const hasExtensionSelector = createSelector(
  extensionIDSelector,
  (eid) => !!eid
);
